module.exports = __webpack_public_path__ + "img/ticimax.b5d01ca2.png";